import dayjs from 'dayjs';

import localization from '../../../shared/strings';

const l10n = localization.OPERATIONS;

export default function formatOperationDate(iso) {
  if (!iso) return '';

  const date = dayjs(iso);
  if (!date.isValid()) return '';

  const time = date.format('H:mm');
  if (date.isSame(dayjs(), 'day')) {
    return l10n.today(time);
  }
  if (date.isSame(dayjs().subtract(1, 'day'), 'day')) {
    return l10n.yesterday(time);
  }
  return l10n.dateAt(date.format('D MMMM'), time);
}
